/**
 * Separated for better code-splitting
 *
 * Todo: replace with union type
 */
export enum SnowflakeType {
  PORTFOLIO,
  WATCHLIST,
  COMPANY,
  TOC,
}
